import { useCallback } from "react";
import { useError } from "../../context/errorContext";

const useCardReader = () => {
    const { showMessage } = useError();

    const readCard = useCallback(async () => {
        try {
            const port = await navigator.serial.requestPort();

            await port.open({
                baudRate: 9600
            });

            const reader = port.readable.getReader();
            const { value } = await reader.read();

            reader.releaseLock();
            await port.close();

            return new TextDecoder().decode(value).trim();

        } catch (error) {
            if (error?.name === "NotFoundError") {
                return null;
            }

            showMessage(error?.message || "RFID Reader konnte nicht gelesen werden.");
            return null;
        }
    }, [showMessage]);

    return { readCard };
};

export default useCardReader;